import axios from 'axios';
import { getStorage } from '@/utility/storage';
// interface PluginSignatureResponse {
//   sig: string;
// }

// const SIGNATURE_URL = 'https://slapp-sandbox.slick-tools.com/api/v1.0/sandbox/getsfxsig';
// const SIGNATURE_URL = 'http://85.13.238.177/screwfix_demo/sig.php';

// https://slapp-prod.slick-tools.com/api/v1.0/recipe/preapply/7d84cd1b120181fc7a11e03ad7392f19/452343-WHI/3S8sAbohlE6j06CY/57e757c1c8ebad5944eaa7ec014aa874
// const BASE = `https://slapp-prod.slick-tools.com/api/v1.0`;
const BASE = '/api/v1.0/login';

const PluginServices = {
  // getSignature({ clid }: { clid: number }) {
  //   return axios.get<PluginSignatureResponse>(SIGNATURE_URL, {
  //     params: { clid },
  //     withCredentials: true,
  //   });
  // },

  getSignature(): Promise<any> {
    const clid = getStorage('clid');
    const URL = `${BASE}/signature?clid=${clid}`;
    return axios.get(URL);
  },

  // api/v1.0/login/signature
  getPreappliedRecipes({ clid, recipe, sig }: { clid: number; recipe: string; sig: string }) {
    // return axios.get(`${BASE}/recipe/preapply/${clid}/${recipe}/${sig}`);
    console.log(clid, recipe, sig);
    return axios.get('./preapply.json', {
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
    });
  },
};

export default PluginServices;
